export default function SVGLights(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M32.0547 11C17.6952 11 6.05469 22.6406 6.05469 37H58.0547C58.0547 22.6406 46.4141 11 32.0547 11Z"
                stroke="#757575"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M32.0547 5V10.2245" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M32.1159 50.0612C24.9025 50.0612 19.0547 44.2135 19.0547 37H45.1771C45.1771 44.2135 39.3295 50.0612 32.1159 50.0612Z"
                stroke="#757575"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M53.4356 50.8576L50.7344 47" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.3847 47L11.0547 50.33" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M45.5529 54.8068L44.0547 52.667" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.7377 52.5488L18.8906 54.3959" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
